//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "@/services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";
import {
  XlsxRead,
  XlsxTable,
  XlsxSheets,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
import invoiceReport from "@/utils/pdfInvoiceReport";
export default {
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    this.mycompany_id = localStorage.getItem(server.COMPANYID);
    await this.loadDepartmentByCompanyId();
    await this.loadCustomer();

    this.$hideLoader();
  },
  components: {
    SuccessDialog,
    XlsxRead,
    XlsxTable,
    XlsxSheets,
    XlsxJson,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      dialogSelectClientInfo: "1",
      dialogSelectTitle: false,
      userrole: "user",
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      company_list: [
        { value: "D", name: "บริษัท เดชอุดม จำกัด" },
        { value: "L", name: "สำนักกฎหมาย เดชอุดม" },
      ],
      showsearchsum: false,
      employeeisdisable: false,
      exportleavereport: "leave_report.xlsx",
      sheets: [
        {
          name: "InvioceReport",
          data: [],
        },
      ],
      search: "",
      headers: [
        {
          text: "Company",
          value: "company_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Department",
          value: "department",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Date",
          value: "inv_date_show",
          class: "bg-colorth tabletextwhite",
          align: "center",
        },
        {
          text: "Client Name",
          value: "cus_name",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Invoice No.",
          value: "inv_id_show",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Status",
          value: "statusshow",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Amount",
          value: "amount_total_show",
          class: "bg-colorth tabletextwhite",
          align: "end",
        },
        {
          text: "Currency",
          value: "currency",
          class: "bg-colorth tabletextwhite",
        },
      ],
      mDataArray: [],
      dataAll: [],
      sum_show_table: [],
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      dateCurrent: this.formatDateday(new Date().toISOString().substr(0, 10)),
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",

      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
      status_list: [
        {
          name: "Draft",
          status_no: 1,
        },
        {
          name: "P.invoice",
          status_no: 2,
        },
        {
          name: "Invoice",
          status_no: 3,
        },
        {
          name: "Void",
          status_no: 4,
        },
        // {
        //   name: "Credit Note",
        //   status_no: 5,
        // },
        // {
        //   name: "Receive",
        //   status_no: 6,
        // },
      ],
      dataformatpr: {
        title: "",
        subtitle: "Invoice Report",
        dateto: "",
        datefrom: "",
      },
      disabled_dep: false,
    };
  },
  methods: {
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddataPagination() {
      var tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.tableLoading = true;

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   1,
        //   this.itemsPerPage,
        //   "id",
        //   "ASC",
        //   localStorage.getItem(server.COMPANYID),
        //   localStorage.getItem(server.DEPARTMENT_ID)
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        this.$showLoader();
        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          1,
          this.itemsPerPage,
          "ih.inv_id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${
                item.cn_inv_id ? `(${item.cn_inv_id})` : ""
              }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${
                  item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center",
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "DESC";
      } else {
        sortDesc = "ASC";
      }

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   options.page,
        //   this.itemsPerPage,
        //   options.sortBy[0],
        //   sortDesc,
        //   localStorage.getItem(server.COMPANYID),
        //   localStorage.getItem(server.DEPARTMENT_ID)
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        //log param
        console.log(`param options:`, JSON.stringify(options));

        this.$showLoader();
        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );

        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${
                item.cn_inv_id ? `(${item.cn_inv_id})` : ""
              }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${
                  item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          // this.$store.state.global_dialog = true;
          // this.setupAlertDialog(
          //   true,
          //   "ค้นหาข้อมูล",
          //   "ไม่มีข้อมูล",
          //   "text-h5 red--text text-center"
          // );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      /*
          page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   pageNumber,
        //   this.itemsPerPage,
        //   "id",
        //   "ASC",
        //   localStorage.getItem(server.COMPANYID),
        //   localStorage.getItem(server.DEPARTMENT_ID)
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        this.$showLoader();
        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          pageNumber,
          this.itemsPerPage,
          "ih.inv_id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${
                item.cn_inv_id ? `(${item.cn_inv_id})` : ""
              }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${
                  item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center",
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.dataAll2 = [];
      this.mDataArray2 = [];
      this.page = 1;
      this.tableLoading = true;

      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      /*
        page,
        limit,
        sortBy,
        sortOrder,
        company_id,
        department_id
     */

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "id",
        sortOrder: "ASC",
        company_id: localStorage.getItem(server.COMPANYID),
        department_id: localStorage.getItem(server.DEPARTMENT_ID),
      };

      try {
        // const result = await api.getdataInvoice_HBycompany_Pagination(
        //   s_data.page,
        //   s_data.limit,
        //   s_data.sortBy,
        //   s_data.sortOrder,
        //   s_data.company_id,
        //   s_data.department_id,
        //   s_data.search
        // );

        // tmp = result.data.data;
        // this.dataAll2 = tmp;
        // this.mDataArray2 = tmp;

        //---------------- New Logic ----------------

        /*
        datasearch: {
        company_inv: "",
        department: 0,
        customer_id: 0,
        inv_type: "",
        status: 0,
        leave_type: 0,
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        company_id: localStorage.getItem(server.COMPANYID),
      },
      */

        /*
          page,
          limit,
          sortBy,
          sortOrder,
          company_id,
          datefrom,
          dateto,
          customer_id ,
          company_inv ,
          department,
          status
     */

        this.$showLoader();
        if (localStorage.getItem("dtime_role") == "ADMIN") {
          if (this.datasearch.department == 0) {
            this.userrole = "admin";
          } else {
            this.userrole = "user";
          }
        } else {
          this.userrole = "user";
        }

        let resultsearch = await api.billing_expense_getdataReportInv_Pagination(
          this.userrole,
          1,
          this.itemsPerPage,
          "ih.inv_id",
          "ASC",
          localStorage.getItem(server.COMPANYID),
          this.datasearch.datefrom,
          this.datasearch.dateto,
          this.datasearch.customer_id,
          this.datasearch.company_inv,
          this.datasearch.department,
          this.datasearch.status,
        );
        let copany_datat = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );

        // console.log(`resultsearch`, JSON.stringify(resultsearch.data.data));

        if (resultsearch.data.data.length > 0) {
          let data_set = resultsearch.data.data;
          data_set.forEach((item, index) => {
            if (item.company_inv == "D") {
              item.company_name = "DEJUDOM & ASSOCIATES LTD.";
            } else {
              item.company_name = "สำนักงานกฎหมาย เดชอุดม";
            }

            //    if (code === "D") return "DEJUDOM & ASSOCIATES LTD.";
            // if (code === "L") return "สำนักงานกฎหมาย เดชอุดม";

            if (item.inv_id != "") {
              item.inv_id_show = `${item.inv_id} ${
                item.cn_inv_id ? `(${item.cn_inv_id})` : ""
              }`;
            } else {
              if (item.pinv_id != "") {
                item.inv_id_show = `${item.pinv_id} ${
                  item.cn_inv_id ? `(${item.cn_inv_id})` : ""
                }`;
              } else {
                item.inv_id_show = "####";
              }
            }
            item.amount_total_show = tolocalestringnumber(
              item.amount_total_after_cal ? item.amount_total_after_cal : 0,
            );
            this.dataAll2[index] = item;
          });
          this.mDataArray2 = this.dataAll2;
          // show pdf

          // await this.setexporttoxlsx();
          if (localStorage.getItem(server.COMPANYID) == 1) {
            if (this.datasearch.company_inv == "L") {
              this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
            } else {
              this.dataformatpr.title = copany_datat.data[0].name;
            }
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }

          this.dataformatpr.datefrom = unity.formatDate(
            this.datasearch.datefrom,
          );
          this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

          this.dataforshowprpo = resultsearch.data.data;
          // await this.checkcontent();
          this.$hideLoader();
        } else {
          this.$hideLoader();
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ค้นหาข้อมูล",
            "ไม่มีข้อมูล",
            "text-h5 red--text text-center",
          );
          return;
        }

        //---------------- New Logic ----------------

        this.totalItems = resultsearch.data.pagination.totalRecords;
        this.page = resultsearch.data.pagination.currentPage;
        this.itemsPerPage = resultsearch.data.pagination.recordsPerPage;
        this.pageCount = resultsearch.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    onCreated(wb) {},
    onChange(wb) {
      const merge = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }];
      wb.Sheets.leavereport.A1 = {
        t: "s",
        v: `Export invoice Repot as of   ${this.dateCurrent}`,
      };
      wb.Sheets.leavereport.B1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.C1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.D1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.E1 = { t: "s", c: 0, v: "" };
      wb.Sheets.leavereport.F1 = { t: "s", v: "" };
      wb.Sheets.leavereport.G1 = { t: "s", v: "" };
      wb.Sheets.leavereport.H1 = { t: "s", v: "" };
      wb.Sheets.leavereport.I1 = { t: "s", v: "" };
      wb.Sheets.leavereport.J1 = { t: "s", v: "" };
      wb.Sheets.leavereport.K1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.L1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.M1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.N1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.O1 = { t: "s", v: "" };
      // wb.Sheets.leavereport.P1 = { t: "s", v: "" };

      wb.Sheets.leavereport.A3 = { t: "s", v: "Employee" };
      wb.Sheets.leavereport.B3 = { t: "s", v: "Leave Type" };
      wb.Sheets.leavereport.C3 = { t: "s", v: "date time from" };
      wb.Sheets.leavereport.D3 = { t: "s", v: "date time to" };
      wb.Sheets.leavereport.E3 = { t: "s", v: "" };
      wb.Sheets.leavereport.F3 = { t: "s", v: "Description" };
      // wb.Sheets.leavereport.I3 = { t: "s", v: "report" };
      // wb.Sheets.leavereport.J3 = { t: "s", v: "payment Request" };
      // wb.Sheets.leavereport.K3 = { t: "s", v: "Cert" };
      // wb.Sheets.leavereport.L3 = { t: "s", v: "Done" };
      // wb.Sheets.leavereport.M3 = { t: "s", v: "Next90" };
      // wb.Sheets.leavereport.N3 = { t: "s", v: "Next60" };

      wb.Sheets.leavereport["!merges"] = merge;
    },
    async loadDepartmentByCompanyId() {
      let result = await api.billing_expense_getAllDepartment_By_CompanyID(
        this.mycompany_id,
      );
      this.department_list = result.data;

      const res_user = await api.getAccountid(
        Number(localStorage.getItem(server.USER_ID)),
      );

      if (
        Number(res_user.data[0].department_i_d) != 6 &&
        Number(localStorage.getItem(server.USER_ID)) != 1
      ) {
        this.disabled_dep = true;
        this.datasearch.department = res_user.data[0].department_i_d;
      } else {
        this.disabled_dep = false;
        this.datasearch.department = res_user.data[0].department_i_d;
      }
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });
      this.customer_list = result.data;
    },

    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {
        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },

    async SearchAlldata() {
      this.datashowAll = [];
      this.lengthAlldatasearch = 0;
      this.dataAll = [];
      this.mDataArray = [];
      this.datasearch.inv_type = "";

      if (this.datasearch.status == 2) {
        this.datasearch.inv_type = "P";
      } else if (this.datasearch.status == 3) {
        this.datasearch.inv_type = "I";
      } else if (this.datasearch.status == 5) {
        this.datasearch.inv_type = "C";
      } else if (this.datasearch.status == 6) {
        this.datasearch.inv_type = "R";
      }

      if (!this.datasearch.datefrom) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateFrom",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (!this.datasearch.dateto) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "กรุณาเลือก DateTo",
          "text-h5 red--text text-center",
        );
        return;
      }

      this.$showLoader();
      let resultsearch = await api.getdataReportInv({
        params: this.datasearch,
      });
      let copany_datat = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID),
      );

      if (resultsearch.data.length > 0) {
        let data_set = resultsearch.data;
        data_set.forEach((item, index) => {
          if (item.inv_id != "") {
            item.inv_id_show = `${item.inv_id} ${
              item.cn_inv_id ? `(${item.cn_inv_id})` : ""
            }`;
          } else {
            if (item.pinv_id != "") {
              item.inv_id_show = `${item.pinv_id} ${
                item.cn_inv_id ? `(${item.cn_inv_id})` : ""
              }`;
            } else {
              item.inv_id_show = "####";
            }
          }
          item.amount_total_show = tolocalestringnumber(
            item.amount_total_after_cal ? item.amount_total_after_cal : 0,
          );
          this.dataAll[index] = item;
        });
        this.mDataArray = this.dataAll;
        // show pdf

        // await this.setexporttoxlsx();
        if (localStorage.getItem(server.COMPANYID) == 1) {
          if (this.datasearch.company_inv == "L") {
            this.dataformatpr.title = `DEJ-UDOM & ASSOCIATES`;
          } else {
            this.dataformatpr.title = copany_datat.data[0].name;
          }
        } else {
          this.dataformatpr.title = copany_datat.data[0].name;
        }

        this.dataformatpr.datefrom = unity.formatDate(this.datasearch.datefrom);
        this.dataformatpr.dateto = unity.formatDate(this.datasearch.dateto);

        this.dataforshowprpo = resultsearch.data;
        // await this.checkcontent();
        this.$hideLoader();
      } else {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ค้นหาข้อมูล",
          "ไม่มีข้อมูล",
          "text-h5 red--text text-center",
        );
        return;
      }
    },

    formatDatetomonthdayyear(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    },
    formatDateday(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    changeformatDatetoinsert(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    async checkcontent() {
      let totalclient = 0;
      this.setdatatoshow = [];
      let linedetailprpo = 40;
      let datainlineprpo = 27;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;

      for (let i = 0; i < this.dataforshowprpo.length; i++) {
        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก

        newhllinedetails = 0;
        getnewdata = [];

        this.dataforshowprpo[i].no = i + 1;

        let stringchecklength = "";

        if (this.dataforshowprpo[i].cus_name != null) {
          let lengthofdataforshowprpo = this.dataforshowprpo[i].cus_name.length;
          stringchecklength = this.dataforshowprpo[i].cus_name;

          for (let j = 0; j < this.dataforshowprpo[i].cus_name.length; j++) {
            if (
              stringchecklength[j] == maiek ||
              stringchecklength[j] == maito ||
              stringchecklength[j] == maitree ||
              stringchecklength[j] == maijattawa ||
              stringchecklength[j] == vowelei ||
              stringchecklength[j] == vowelee ||
              stringchecklength[j] == voweleue ||
              stringchecklength[j] == voweleu ||
              stringchecklength[j] == vowelu ||
              stringchecklength[j] == voweluu ||
              stringchecklength[j] == maihun ||
              stringchecklength[j] == maiyamok
            ) {
              lengthofdataforshowprpo--;
            }
          }

          newhllinedetails = Math.ceil(
            lengthofdataforshowprpo / datainlineprpo,
          );

          getnewdata.push(this.dataforshowprpo[i]);

          if (
            hllinedetails + newhllinedetails > linedetailprpo ||
            this.dataforshowprpo[i].changedepartment == true
          ) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            this.pageAll++;

            hllinedetails = 0;
            getdata = [];
            getdata.push(this.dataforshowprpo[i]);
            hllinedetails += newhllinedetails;
            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          } else {
            hllinedetails += newhllinedetails;

            getdata.push(this.dataforshowprpo[i]);

            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          }
        } else {
          if (this.dataforshowprpo[i].department == null) {
            this.dataforshowprpo[i].department = "-";
          }
          let lengthofdataforshowprpo = this.dataforshowprpo[i].department
            .length;
          stringchecklength = this.dataforshowprpo[i].department;

          for (let j = 0; j < this.dataforshowprpo[i].department.length; j++) {
            if (
              stringchecklength[j] == maiek ||
              stringchecklength[j] == maito ||
              stringchecklength[j] == maitree ||
              stringchecklength[j] == maijattawa ||
              stringchecklength[j] == vowelei ||
              stringchecklength[j] == vowelee ||
              stringchecklength[j] == voweleue ||
              stringchecklength[j] == voweleu ||
              stringchecklength[j] == vowelu ||
              stringchecklength[j] == voweluu ||
              stringchecklength[j] == maihun ||
              stringchecklength[j] == maiyamok
            ) {
              lengthofdataforshowprpo--;
            }
          }

          newhllinedetails = Math.ceil(
            lengthofdataforshowprpo / datainlineprpo,
          );

          getnewdata.push(this.dataforshowprpo[i]);

          if (
            hllinedetails + newhllinedetails > linedetailprpo ||
            this.dataforshowprpo[i].changedepartment == true
          ) {
            this.setdatatoshow[this.pageAll - 1] = getdata;
            this.pageAll++;

            hllinedetails = 0;
            getdata = [];
            getdata.push(this.dataforshowprpo[i]);
            hllinedetails += newhllinedetails;
            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          } else {
            hllinedetails += newhllinedetails;

            getdata.push(this.dataforshowprpo[i]);

            if (i == this.dataforshowprpo.length - 1) {
              this.dataforshowprpo[i].totalclient = totalclient.toFixed(2);
              this.setdatatoshow[this.pageAll - 1] = getdata;
              getdata = [];
            }
          }
        }
      }

      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;

      this.setdatatoshow.forEach((item, iitem) => {
        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
    },
    buildInvoiceContent() {
      const data = this.mDataArray2 || [];

      // 🔥 sort: department → date
      const sorted = [...data].sort((a, b) => {
        const deptA = a.department || "Other Departments";
        const deptB = b.department || "Other Departments";

        // 🔥 ดัน Other Departments ไปท้ายสุด
        if (deptA === "Other Departments" && deptB !== "Other Departments")
          return 1;
        if (deptA !== "Other Departments" && deptB === "Other Departments")
          return -1;

        // ปกติ sort ตามชื่อ department
        if (deptA !== deptB) {
          return deptA.localeCompare(deptB);
        }

        // แล้วค่อย sort date
        return new Date(a.inv_date_pdf) - new Date(b.inv_date_pdf);
      });

      const departmentMap = new Map();

      sorted.forEach((row) => {
        const deptKey = row.department || "Other Departments";
        const dateKey = row.inv_date_pdf;

        // ===== DEPARTMENT =====
        if (!departmentMap.has(deptKey)) {
          departmentMap.set(deptKey, {
            department_name: deptKey,
            dates: new Map(),
          });
        }

        const department = departmentMap.get(deptKey);

        // ===== DATE =====
        if (!department.dates.has(dateKey)) {
          department.dates.set(dateKey, {
            date: dateKey,
            items: [],
          });
        }

        const dateGroup = department.dates.get(dateKey);

        // ===== ITEM =====
        dateGroup.items.push({
          client_name: row.cus_name || "",
          invoice_no: row.inv_id_show ? row.inv_id_show : "####",
          amount: Number(
            String(row.amount_total_after_cal || 0).replace(/,/g, ""),
          ),
          currency: row.currency || "",
          status: row.statusshow || "",
        });
      });

      // 🔥 convert Map → Array
      return Array.from(departmentMap.values()).map((dept) => ({
        department_name: dept.department_name,
        dates: Array.from(dept.dates.values()),
      }));
    },
    async opendata() {
      if (
        Number(localStorage.getItem(server.COMPANYID)) != 1 &&
        Number(localStorage.getItem(server.COMPANYID)) != 3
      ) {
        await this.exportToPDF();
      } else {
        this.dialogSelectTitle = true;
      }
    },
    async exportToPDF() {
      this.dialogSelectTitle = false;
      this.$showLoader();

      var res_company = [];
      if (Number(localStorage.getItem(server.COMPANYID)) != 1) {
        res_company = await api.getCompanyByID(
          localStorage.getItem(server.COMPANYID),
        );
      } else {
        res_company = await api.getCompanyByID(
          Number(this.dialogSelectClientInfo),
        );
      }
      var pdfheader = {};

      pdfheader = {
        company_name_en: res_company.data[0].name || "",
        company_name_th: res_company.data[0].inv_company_name_th || "",
        date_from: this.datasearch.datefrom,
        date_to: this.datasearch.dateto,
      };

      // const content = [
      //   {
      //     department_name: "ACCOUNTING",
      //     dates: [
      //       {
      //         date: "2025-12-01",
      //         items: [
      //           {
      //             client_name: "Client A",
      //             invoice_no: "INV001",
      //             amount: 12500.5,
      //             currency: "THB",
      //             status: "PAID"
      //           },
      //           {
      //             client_name: "Client B",
      //             invoice_no: "INV002",
      //             amount: 8200,
      //             currency: "USD",
      //             status: "PENDING"
      //           }
      //         ]
      //       },
      //       {
      //         date: "2025-12-02",
      //         items: [
      //           {
      //             client_name: "Client C",
      //             invoice_no: "INV003",
      //             amount: 4500,
      //             currency: "THB",
      //             status: "CANCEL"
      //           }
      //         ]
      //       }
      //     ]
      //   },

      //   {
      //     department_name: "IP",
      //     dates: [
      //       {
      //         date: "2025-12-01",
      //         items: [
      //           {
      //             client_name: "Client D",
      //             invoice_no: "INV004",
      //             amount: 3000,
      //             currency: "USD",
      //             status: "PAID"
      //           }
      //         ]
      //       }
      //     ]
      //   },

      //   {
      //     department_name: "LITIGATION",
      //     dates: [
      //       {
      //         date: "2025-12-03",
      //         items: [
      //           {
      //             client_name: "Client E",
      //             invoice_no: "INV005",
      //             amount: 15000,
      //             currency: "THB",
      //             status: "PENDING"
      //           }
      //         ]
      //       }
      //     ]
      //   }
      // ];

      const content = this.buildInvoiceContent();
      const datatest = {
        header: pdfheader,
        content: content,
      };
      await invoiceReport.exportToPDF(datatest);
      this.$hideLoader();
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
